module.exports = __webpack_public_path__ + "img/098.c8846b3e.png";